import styled, { keyframes } from 'styled-components';

export const AiBtnWhite = styled.button`
  padding: 10px 20px;
  background-color: rgba(255,255,255,0.5);
  border-radius: 5px;
  color: #000000;
  border: 1px solid #dedede;
  cursor: pointer;
  transition-duration: 200ms;
  &:hover {
    transition-duration: 200ms;
    background-color: rgba(23, 125, 214, 0.2);    
  }
`;

export const AiModalCloseBtn = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  font-size: 24px;
  line-height: 24px;
  width: 24px;
  height: 24px;

  border: none;
  background: none;
  padding: 0;
  color: rgba(78, 78, 78, .35);

  &:hover {
    color: rgba(78, 78, 78, .6);
    cursor: pointer;
  }
`;

export const AiModalStyledTextHolder = styled.div`
  font-family: "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  color: #1D1D1F;

  font-size: 14px;
  border-color: rgb(204, 204, 204);
  
  resize:none;
  width: 600px;
  max-width: 600px;
  height: auto;

  text-align: justify;
  white-space: pre-wrap;

  user-select: text;

  &:focus {
    outline-color: transparent;
    outline-style: none;
  }
`;

const flick = keyframes`
  0% {
    background-position-x: -237px;
  }
  100% {
    background-position-x: 237px;
  }
`;

export const AiTextLoadingPlaceholder = styled.span`
  color: transparent;
  background: linear-gradient(90deg, rgba(150,150,150,1) 0%, rgba(100,100,100,1) 50%, rgba(150,150,150,1) 100%);
  background-size: calc(237px) 100%;
  -webkit-background-clip: text;
  animation: ${flick} 1.3s  infinite;
`;

export const AiModal = styled.div`
  display: flex;
  flex-direction: column;
  padding: 4px 16px 8px 16px;
`;

export const AiModalHeader = styled.div`
  font-family: "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  color: rgb(124, 124, 124);
  padding-top: 0;
  padding-bottom: 0;

  user-select: text;
`;

export const AiModalBody = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: column;
`;

export const AiModalFooter = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
`;
